import { PlatformPlan } from "Generated/graphql-types"

/* eslint-disable @typescript-eslint/no-empty-interface */
const config = { domain: 'Fundraising', subdomain: 'Donations' }

interface SetupDonationsClicked {
  orgId: number
  userId: number
}

interface ResumeDonationsClicked {
  orgId: number
  userId: number
}

interface EditPortalClicked {
  orgId: number
  userId: number
}

interface EditPublicPortalClicked {
  orgId: number
  userId: number
}

interface EditDraftPortalClicked {
  orgId: number
  userId: number
}

interface ConvertToDraftClicked {
  orgId: number
  userId: number
}

interface ArchiveDraftClicked {
  orgId: number
  userId: number
}

interface SharePortalClicked {
  orgId: number
  userId: number
  useWindowLocation: boolean
}
interface ConfirmArchiveDraftClicked {
  orgId: number
  userId: number
}

interface ConfirmDraftClicked {
  orgId: number
  userId: number
}
interface CancelDraftClicked {
  orgId: number
  userId: number
}

interface CancelArchiveDraftClicked {
  orgId: number
  userId: number
}

interface SavePortalClicked {
  orgId: number
  userId: number
}

interface SavePublicPortalClicked {
  orgId: number
  userId: number
}

interface SaveDraftPortalClicked {
  orgId: number
  userId: number
}

interface AccountReturnToCampaignsClicked {
  orgId: number
  userId: number
}

interface FilterDateClicked {
  orgId: number
  userId: number
}

interface FiltersSubmitted {
  userId: number
  datesOption: string
  dateStart: string | null
  dateEnd: string | null
  donationAmount: string
  statusSuccess: boolean
  statusPending: boolean
  statusFailed: boolean
}

interface DownloadDonorReportClicked {
  userId: number
}
interface DownloadTransactionsReportClicked {
  userId: number
}
interface DownloadReportClicked {
  userId: number
}

interface DonationClicked {
  userId: number
  donationId: string
  donationStatus: string
  donationAmount: number
}

interface CreateStoryClicked {
  userId: number
}

interface StoryClicked {
  userId: number
  storyId: string
}

interface CampaignClicked {
  userId: number
  campaignId: string
}

interface CreateCampaignClicked {
  userId: number
}

interface transactionReviewClicked {
  userId: number
  donationId: string
  donationStatus: string
  donationAmount: number
}
interface DonationPortalShareToFacebookClicked {
  donationPortalId: number
  useWindowLocation: boolean
}
interface DonationPortalShareToTwitterClicked {
  donationPortalId: number
  useWindowLocation: boolean
}
interface DonationPortalShareToLinkedInClicked {
  donationPortalId: number
  useWindowLocation: boolean
}
interface DonationPortalShareToEmailClicked {
  donationPortalId: number
  useWindowLocation: boolean
}
interface DonationPortalId {
  donationPortalId: number
  useWindowLocation: boolean
}

interface Clicked { }

interface EditDonationTipViewed {
  tipId: string
}

interface EditDonationTipAcknowledged {
  tipId: string
}

interface SaveLogoClicked {
  orgId: number
  userId: number
}

interface QrClicked {
  orgId: number
  userId: number
  campaignId: string
  platformPlan: PlatformPlan | null
  funderOrgId: number
  useWindowLocation: boolean
}

// CAMPAIGN OPTIMIZATION
interface OptimizationEvent {
  nonprofitOrgID: number
  userId: number
  campaignId: string
  platformPlan: PlatformPlan | null
  funderOrgId: number
}

interface AIDialogOpenClicked extends OptimizationEvent { }
interface AIDialogCloseClicked extends OptimizationEvent { }
interface AIDialogOptimizeClicked extends OptimizationEvent { }
interface AIDialogConfirmationClicked extends OptimizationEvent { }

export const donations = {
  AI_Dialog_Open_Clicked: {
    AI_Dialog_Open_Clicked: (param: AIDialogOpenClicked) => param,
    config,
  },
  AI_Dialog_Close_Clicked: {
    AI_Dialog_Close_Clicked: (param: AIDialogCloseClicked) => param,
    config,
  },
  AI_Dialog_Optimize_Clicked: {
    AI_Dialog_Optimize_Clicked: (param: AIDialogOptimizeClicked) => param,
    config,
  },
  AI_Dialog_Confirmation_Clicked: {
    AI_Dialog_Confirmation_Clicked: (param: AIDialogConfirmationClicked) =>
      param,
    config,
  },
  Setup_Clicked: {
    Setup_Clicked: (param: SetupDonationsClicked) => param,
    config,
  },
  Resume_Donations_Clicked: {
    Resume_Donations_Clicked: (param: ResumeDonationsClicked) => param,
    config,
  },
  ResumeSetup_Clicked: {
    ResumeSetup_Clicked: (param: ResumeDonationsClicked) => param,
    config,
  },
  PreSetupModal_Clicked: {
    PreSetupModal_Clicked: (param: ResumeDonationsClicked) => param,
    config,
  },
  Edit_Portal_Clicked: {
    Edit_Portal_Clicked: (param: EditPortalClicked) => param,
    config,
  },
  EditPublic_Portal_Clicked: {
    EditPublic_Portal_Clicked: (param: EditPublicPortalClicked) => param,
    config,
  },
  EditDraft_Portal_Clicked: {
    EditDraft_Portal_Clicked: (param: EditDraftPortalClicked) => param,
    config,
  },
  ConvertToDraft_Clicked: {
    ConvertToDraft_Clicked: (param: ConvertToDraftClicked) => param,
    config,
  },
  ArchiveDraft_Clicked: {
    ArchiveDraft_Clicked: (param: ArchiveDraftClicked) => param,
    config,
  },
  Share_Portal_Clicked: {
    Share_Portal_Clicked: (param: SharePortalClicked) => param,
    config,
  },
  ConfirmDraft_Clicked: {
    ConfirmDraft_Clicked: (param: ConfirmDraftClicked) => param,
    config,
  },
  CancelDraft_Clicked: {
    CancelDraft_Clicked: (param: CancelDraftClicked) => param,
    config,
  },
  ConfirmArchiveDraft_Clicked: {
    ConfirmArchiveDraft_Clicked: (param: ConfirmArchiveDraftClicked) => param,
    config,
  },
  CancelArchiveDraft_Clicked: {
    CancelArchiveDraft_Clicked: (param: CancelArchiveDraftClicked) => param,
    config,
  },
  Save_Portal_Clicked: {
    Save_Portal_Clicked: (param: SavePortalClicked) => param,
    config,
  },
  SavePublic_Portal_Clicked: {
    SavePublic_Portal_Clicked: (param: SavePublicPortalClicked) => param,
    config,
  },
  SaveDraft_Portal_Clicked: {
    SaveDraft_Portal_Clicked: (param: SaveDraftPortalClicked) => param,
    config,
  },
  Account_ReturnToCampaigns_Clicked: {
    Account_ReturnToCampaigns_Clicked: (
      param: AccountReturnToCampaignsClicked
    ) => param,
    config: { domain: '', subdomain: '' },
  },

  Filter_Date_Clicked: {
    Filter_Date_Clicked: (param: FilterDateClicked) => param,
    config,
  },
  Filters_Submitted: {
    Filters_Submitted: (param: FiltersSubmitted) => param,
    config,
  },
  Download_Report_Clicked: {
    Download_Report_Clicked: (param: DownloadReportClicked) => param,
    config,
  },
  Download_TransactionsReport_Clicked: {
    Download_TransactionsReport_Clicked: (
      param: DownloadTransactionsReportClicked
    ) => param,
    config,
  },
  Download_DonorReport_Clicked: {
    Download_DonorReport_Clicked: (param: DownloadDonorReportClicked) => param,
    config,
  },
  Donation_Clicked: {
    Donation_Clicked: (param: DonationClicked) => param,
    config,
  },
  Create_Story_Clicked: {
    Create_Story_Clicked: (param: CreateStoryClicked) => param,
    config,
  },
  Story_Clicked: {
    Story_Clicked: (param: StoryClicked) => param,
    config,
  },
  Campaign_Clicked: {
    Campaign_Clicked: (param: CampaignClicked) => param,
    config,
  },
  Create_Campaign_Clicked: {
    Create_Campaign_Clicked: (param: CreateCampaignClicked) => param,
    config,
  },
  Clicked: {
    Clicked: (param: Clicked) => param,
    config,
  },
  Transaction_Review_Clicked: {
    Transaction_Review_Clicked: (param: transactionReviewClicked) => param,
    config,
  },
  Share_Donation_Portal_To_Facebook_Clicked: {
    Share_Donation_Portal_To_Facebook_Clicked: (
      param: DonationPortalShareToFacebookClicked
    ) => param,
    config,
  },
  Share_Donation_Portal_To_LinkedIn_Clicked: {
    Share_Donation_Portal_To_LinkedIn_Clicked: (
      param: DonationPortalShareToLinkedInClicked
    ) => param,
    config,
  },
  Share_Donation_Portal_To_Twitter_Clicked: {
    Share_Donation_Portal_To_Twitter_Clicked: (
      param: DonationPortalShareToTwitterClicked
    ) => param,
    config,
  },
  Share_Donation_Portal_To_Email_Clicked: {
    Share_Donation_Portal_To_Email_Clicked: (
      param: DonationPortalShareToEmailClicked
    ) => param,
    config,
  },
  Copy_Donation_Portal_Link_Clicked: {
    Copy_Donation_Portal_Link_Clicked: (param: DonationPortalId) => param,
    config,
  },
  Edit_Donation_Tip_Viewed: {
    Edit_Donation_Tip_Viewed: (param: EditDonationTipViewed) => param,
    config,
  },
  Edit_Donation_Tip_Acknowledged: {
    Edit_Donation_Tip_Acknowledged: (param: EditDonationTipAcknowledged) =>
      param,
    config,
  },
  Save_Logo_Clicked: {
    Save_Logo_Clicked: (param: SaveLogoClicked) => param,
    config,
  },

  Share_Donation_Portal_QR_clicked: {
    Share_Donation_Portal_QR_clicked: (param: QrClicked) => param,
    config,
  },

  Share_Donation_Portal_Print_clicked: {
    Share_Donation_Portal_Print_clicked: (param: QrClicked) => param,
    config,
  },
}
